import React, { Component } from 'react';

export default class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <footer className="s-footer">
          <div className="row">
            <div className="column large-4 medium-6 w-1000-stack s-footer__social-block">
              <ul className="s-footer__social">
                <li>
                  <a href="https://www.linkedin.com/in/robert-quan/">
                    <i className="fab fa-linkedin" aria-hidden="true" />
                  </a>
                </li>
                <li>
                  {' '}
                  <a href="https://github.com/hquan212">
                    <i className="fab fa-github" aria-hidden="true" />
                  </a>
                </li>
                <li>
                  {' '}
                  <a href="https://medium.com/@hquan212">
                    <i className="fab fa-medium" aria-hidden="true" />
                  </a>
                </li>
                <li>
                  {' '}
                  <a href="https://hired.com/x/9cedf57463c0596f8cc43cb39a8cd6e6">
                    <i className="fab fa-black-tie" aria-hidden="true" />
                  </a>
                </li>
              </ul>
            </div>
            <div className="column large-7 medium-6 w-1000-stack ss-copyright">
              <span>© Copyright Ceevee 2021</span>
              <span>
                Design by <a href="https://www.styleshout.com/">StyleShout</a>
              </span>
            </div>
          </div>
          <div className="s-hero__scroll">
            <a href="/" className="s-hero__scroll-link smoothscroll">
              <span className="scroll-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  style={{
                    fill: 'rgba(0, 0, 0, 1)',
                    transform: '',
                    msFilter: '',
                  }}
                >
                  <path d="M6 4h12v2H6zm5 10v6h2v-6h5l-6-6-6 6z" />
                </svg>
              </span>
              <span className="smoothscroll">Scroll Up</span>
            </a>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}
